import { Link } from "react-router-dom";
import { Building2, HomeIcon, ArrowRight } from "lucide-react";

const OPTIONS = [
  {
    href: "/anfrage-betrieb",
    icon: Building2,
    eyebrow: "Für Gastronomie & Betriebe",
    title: "Mietkoch",
    description:
      "Verstärkung in bestehenden Küchen — Restaurants, Hotels, Firmenevents, Bankette. Ich koche in Ihrem Betrieb nach Ihrem Konzept.",
    bullets: [
      "Personalausfall überbrücken",
      "Saisonspitzen und Feiertage",
      "À-la-carte-Service, Bankette, Hotels",
      "Ab 49 € netto/h (Werktag)",
    ],
    cta: "Mietkoch anfragen",
    testid: "anfrage-choice-betrieb",
  },
  {
    href: "/anfrage-privat",
    icon: HomeIcon,
    eyebrow: "Für Privatpersonen",
    title: "Privatkoch",
    description:
      "Menü-Abend bei Ihnen zuhause — frisch in Ihrer Küche gekocht, am gedeckten Tisch serviert. Ab 2 Gästen — größere Runden auf Anfrage.",
    bullets: [
      "Menü nach Ihren Wünschen (3–7 Gänge)",
      "Ich koche und serviere bei Ihnen",
      "Küche wird sauber übergeben",
      "Kein Buffet, kein mobiles Catering",
    ],
    cta: "Menü-Abend anfragen",
    testid: "anfrage-choice-privat",
  },
];

export default function Anfrage() {
  return (
    <div className="max-w-6xl mx-auto px-6 md:px-12 py-16 md:py-24" data-testid="anfrage-chooser">
      <p className="text-[10px] uppercase tracking-[0.35em] text-[#BA6D52]">Anfrage stellen</p>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter mt-6 max-w-3xl">
        Was passt zu Ihrem Anlass?
      </h1>
      <p className="text-[#757067] font-light text-lg mt-6 max-w-2xl leading-relaxed">
        Ich arbeite in zwei Formaten — bitte wählen Sie eines aus, damit ich Ihre Anfrage
        so schnell wie möglich mit den richtigen Fragen beantworten kann.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mt-12 md:mt-16">
        {OPTIONS.map((opt) => {
          const Icon = opt.icon;
          return (
            <Link
              key={opt.href}
              to={opt.href}
              data-testid={opt.testid}
              className="group block border border-[#E3DECE] bg-white hover:border-[#BA6D52] hover:shadow-lg transition-all p-8 md:p-10"
            >
              <div className="flex items-start justify-between gap-4">
                <div className="w-14 h-14 border-2 border-[#BA6D52] text-[#BA6D52] flex items-center justify-center group-hover:bg-[#BA6D52] group-hover:text-white transition-colors">
                  <Icon size={26} strokeWidth={1.5} />
                </div>
                <span className="text-[10px] uppercase tracking-[0.25em] text-[#BA6D52] mt-3">{opt.eyebrow}</span>
              </div>

              <h2 className="font-serif text-3xl md:text-4xl font-light mt-8 tracking-tighter text-[#2C2A26]">{opt.title}</h2>
              <p className="text-[#5C574E] font-light mt-4 leading-relaxed">{opt.description}</p>

              <ul className="mt-6 space-y-2 text-sm text-[#2C2A26]">
                {opt.bullets.map((b) => (
                  <li key={b} className="flex items-start gap-2">
                    <span className="text-[#BA6D52] mt-1">·</span>
                    <span>{b}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 pt-6 border-t border-[#E3DECE] flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#BA6D52] group-hover:gap-4 transition-all">
                {opt.cta} <ArrowRight size={16} />
              </div>
            </Link>
          );
        })}
      </div>

      <p className="text-sm text-[#8A7A68] mt-12 max-w-2xl italic">
        Nicht sicher, was passt? Schreiben Sie mir einfach über die{" "}
        <Link to="/kontakt" className="underline underline-offset-4 hover:text-[#BA6D52]">
          Kontaktseite
        </Link>{" "}
        — ich melde mich innerhalb 24 Stunden.
      </p>
    </div>
  );
}
